<template>

  <div class="mall">
    <van-search
      v-model="value"
      placeholder="请输入关键字"
      shape="round"
      @search="onSearch"
    />
    <van-swipe
      :autoplay="3000"
      :show-indicators="false"
    >
      <van-swipe-item
        v-for="(image, index) in bannerlist"
        :key="index"
      >
        <img
          :src="image"
          class="banner"
          @click="gorouter()"
        >
      </van-swipe-item>
    </van-swipe>

    <!-- <div class="otherbox">
      <van-cell
        value="更多"
        is-link
      >
        <template slot="title">
          <img
            src="../../assets/images/mall/1.png"
            class="left-icon"
            @click="gorouter()"
          >
          <span class="custom-text">精准量测系列</span>
        </template>
      </van-cell>
      <div class="content">
        <div class="content-left">
          <img
            src="../../assets/images/goods/pr/9.jpg"
            class="leftImg1"
            @click="gorouter()"
          >
        </div>
        <div class="content-left">
          <img
            src="../../assets/images/goods/pr/10.jpg"
            class="leftImg"
            @click="gorouter()"
          >
          <img
            src="../../assets/images/goods/pr/11.jpg"
            class="leftImg"
            @click="gorouter()"
          >
        </div>
      </div> -->

    <!-- <van-cell
      value="更多"
      is-link
    >
      <template slot="title">
        <img
          src="../../assets/images/mall/2.png"
          class="left-icon"
        >
        <span class="custom-text">穿戴设备系列</span>
      </template>
    </van-cell>
    <div class="content contentbg">
      <div class="sy-cell">
        <img
          src="../../assets/images/goods/pr/1.jpg"
          class="cellimg"
          @click="gorouter()"
        >
        <img
          src="../../assets/images/goods/pr/4.jpg"
          class="cellimg"
          @click="gorouter()"
        >
        <img
          src="../../assets/images/goods/pr/3.jpg"
          class="cellimg"
          @click="gorouter()"
        >
      </div>-->
    <div class="sy-cell_center margin12">
      <div class="line" />
      <div class="font18 colorOrage">
        精准测量系列产品
      </div>
      <div class="line" />
    </div>
    <div>

      <div class="sy-cell_around flexwap">
        <div
          v-for="item in list1"
          :key="item"
          class="shopbox"
          @click="gorouter()"
        >
          <img
            :src="item.img"
            class="shopImg"
          >
          <div class="goods-bd">
            <div class="title text-line-1">
              {{ item.title }}
            </div>
            <div class="money">
              ￥0 + 100健康币
            </div>
            <div class="buycount">
              125人付款 北京
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="sy-cell_center margin12">
      <div class="line" />
      <div class="font18 colorOrage">
        穿戴设备系列产品
      </div>
      <div class="line" />
    </div>
    <div>
      <div class="sy-cell_around flexwap">
        <div
          v-for="item in list2"
          :key="item"
          class="shopbox"
          @click="gorouter()"
        >
          <img
            :src="item.img"
            class="shopImg"
          >
          <div class="goods-bd">
            <div class="title text-line-1">
              {{ item.title }}
            </div>
            <div class="money">
              ￥0 + 100健康币
            </div>
            <div class="buycount">
              125人付款 北京
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="sy-cell_center margin12">
      <div class="line" />
      <div class="font18 colorOrage">
        远程医疗系列产品
      </div>
      <div class="line" />
    </div>
    <div>
      <div class="sy-cell_around flexwap">
        <div
          v-for="item in list3"
          :key="item"
          class="shopbox"
          @click="gorouter()"
        >
          <img
            :src="item.img"
            class="shopImg"
          >
          <div class="goods-bd">
            <div class="title text-line-1">
              {{ item.title }}
            </div>
            <div class="money">
              ￥0 + 100健康币
            </div>
            <div class="buycount">
              125人付款 北京
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="sy-cell_center margin12">
      <div class="line" />
      <div class="font18 colorOrage">
        创新医疗系列产品
      </div>
      <div class="line" />
    </div>
    <div>
      <div class="sy-cell_around flexwap">
        <div
          v-for="item in list4"
          :key="item"
          class="shopbox"
          @click="gorouter()"
        >
          <img
            :src="item.img"
            class="shopImg"
          >
          <div class="goods-bd">
            <div class="title text-line-1">
              {{ item.title }}
            </div>
            <div class="money">
              ￥0 + 100健康币
            </div>
            <div class="buycount">
              125人付款 北京
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      images: [
        'http://pic37.nipic.com/20140113/8800276_184927469000_2.png',
        'http://pic.58pic.com/58pic/13/82/74/92q58PICeSI_1024.jpg'
      ],
      bannerlist: [
        require('../../assets/images/goods/banner1.png'),
        require('../../assets/images/goods/banner2.png'),
        require('../../assets/images/goods/banner3.png')
      ],
      list1: [
        {
          title: 'Fora体温计  IR21',
          img: require('../../assets/images/goods/pr/9.jpg')
        },
        {
          title: 'Fora体重计  W310',
          img: require('../../assets/images/goods/pr/10.jpg')
        },
        {
          title: 'Fora血糖计 GD40',
          img: require('../../assets/images/goods/pr/11.jpg')
        },
        {
          title: 'Fora血压计 P30 Plus',
          img: require('../../assets/images/goods/pr/12.jpg')
        }
      ],
      list2: [
        {
          title: 'RingmiiHV  500S',
          img: require('../../assets/images/goods/pr/2.jpg')
        },
        {
          title: 'Sariel 守护天使 800V',
          img: require('../../assets/images/goods/pr/4.jpg')
        },
        {
          title: 'RingmiiHX  500H',
          img: require('../../assets/images/goods/pr/1.jpg')
        },
        {
          title: 'Gabriel 尊爵天使 900M',
          img: require('../../assets/images/goods/pr/3.jpg')
        }
      ],

      list3: [
        {
          title: '智慧云端健康量测便利站 M1000',
          img: require('../../assets/images/goods/pr/13.jpg')
        }
      ],
      list4: [
        {
          title: '新美特健康小助手',
          img: require('../../assets/images/goods/pr/5.png')
        },
        {
          title: '心脏健康电子听诊器',
          img: require('../../assets/images/goods/pr/8.jpg')
        },
        {
          title: '十二导无线心电监护仪 MCE12L001',
          img: require('../../assets/images/goods/pr/6.jpg')
        }, {
          title: '无创血糖仪  CGM100',
          img: require('../../assets/images/goods/pr/7.jpg')
        }
      ],
      loading: false,
      finished: false,
      value: ''
    }
  },
  created() {},
  methods: {
    onSearch(value) {
    },
    onLoad() {
      // 异步更新数据
    },
    gorouter() {
      this.$router.push('/goods')
    }
  }
}
</script>

<style scoped lang="scss" >
.mall{
  background:#fff;
}
.banner {
  width: 100%;
}
.van-search {
  width: 100%;

  .van-search__content {
    background: #eee;
  }
}
.left-icon {
  width: 11px;
  height: 13px;
  margin-right: 7px;
}
.otherbox {
  .van-cell {
    background-color: transparent;
    padding: 8px 12.5px;
    .custom-text {
      font-size: 18px;
    }
    .van-cell__value {
      color: #333;
    }
  }
}
.content {
  //  padding:0 12.5px;
  box-sizing: border-box;
  .content-left {
    width: 50%;
    height: auto;
    float: left;
    .leftImg1 {
      width: 50vw;
      height: 172px;
    }
    .leftImg {
      width: 50vw;
      height: 86px;
      vertical-align: middle;
    }
  }
}
.cellimg {
  width: 33.333333%;
  height: 136px;
}
.shopbox {
  width: 185px;
  background: #fff;
  margin-bottom: 3px;
  .shopImg {
    width: 186px;
    height: 186px;
    display: block;
  }
  .goods-bd {
    padding: 10px 15px;
  }
  .title {
    // font-size: 16px;
  }
  .money {
    color: rgba(255, 118, 14, 1);
    margin-left: -4px;
  }
  .buycount {
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
  }
}
.margin12 {
  margin: 12px 0px;
}
.contentbg{
  background: #F9F9F9;
}
</style>
